export interface IPlayer {
    isLocal(): boolean
}

export default abstract class Player implements IPlayer {
    abstract isLocal(): boolean
}